module.exports = __webpack_public_path__ + "static/img/h-second.6a3093a0.png";